module.exports = __webpack_public_path__ + "static/media/BDBT01.03526fec.jpg";